import { render, staticRenderFns } from "./FixedNav.vue?vue&type=template&id=86c38488&"
import script from "./FixedNav.vue?vue&type=script&lang=ts&"
export * from "./FixedNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports